import React from 'react';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import ToolFileExplorer from './ToolFileExplorer';
import Loader from '../../react-fullpage-custom-loader/dist/index'
import SearchBar from './SearchBar'
import {ControlledMenu, MenuItem} from '../../react-menu/dist'
import './collapse.css';
import objeler from '../objeler';
import {setVisibility} from '../Functions/funcs';

const btnMenuItemClass = ' text-gray-600  hover:bg-blue-50    ';
const btnMenuTextClass = "text-sm text-gray-600";
const btnMenuIconSize = "1.1em";
const btnMenuIconWidth = "23px";
type Props = {
    description: string,
    title: string,
    tools: [],
    collapse: boolean
};
type State = {
    collapse: boolean,
    SearchResults: String
};

class PanelFileExplorer extends React.Component<Props, State> {
    state = {
        collapse: false,
        SearchResults: objeler.userFiles
    };

    constructor(props) {
        super(props);
    }

    deleteFileOK(e) {
        this.props.DeleteFile(e)
        console.log('this.searchBar', objeler)
    }

    setList = (e) => {
        this.setState({SearchResults: e})
    }

    /**
     * Called from the right-click "Share with Team" item.
     * Delegates to the funcs.js helper which hits the backend
     * and refreshes the file list on success.
     */
    handleShareWithTeam = () => {
        const target = this.state.FileName;
        if (!target) return;
        setVisibility(target, 'account');
    }

    /**
     * Called from the right-click "Make Private" item.
     * Mirror of handleShareWithTeam, opposite direction.
     */
    handleMakePrivate = () => {
        const target = this.state.FileName;
        if (!target) return;
        setVisibility(target, 'private');
    }
    deleteFile = (e) => {
        const {alert} = objeler.Editor.props;
        alert.success(e + " will be deleted.Are you sure?", true
            , {
                title: "Warning",
                closeCopy: "Cancel",
                actions: [
                    {
                        copy: "OK",
                        onClick: () => {
                            this.deleteFileOK(e)
                        },
                    }
                ]
            }
        );
    }
    componentDidMount = () => {
        const {collapse, tools} = this.props;
        this.setState({
            collapse,
            SearchResults: tools,
            AnchorPoint: {x: 0, y: 0},
            ContextMenuState: 'closed',
        });
        // console.log('>>>>>>>>>>>>>>>', this.state.SearchResults)
        // console.log('>>>>>>>>>>>>>>>', tools)
    };
    toggle = () => {
        this.setState(state => ({
            collapse: !state.collapse
        }));
    };
    render = () => {
        const {title, description, tools, minWidth, maxWidth, ShowLoaderFile} = this.props;
        const {collapse} = this.state;
        var liste = this.state.SearchResults
        if (this.state.SearchResults == undefined)
            liste = tools
        return (
            <div
            >
                <img src=""
                     id="thumb-popup"
                     className="popup" style={{
                    display: 'block',
                    backgroundColor: 'transparent',
                    border: 'solid',
                    borderWidth: 'thin',
                    borderColor: 'lightgrey'
                    ,
                    transition: 'none'
                }}
                />
                <div className="rounded-lg border border-grey-light bg-white mb-5 w-full "
                     style={{
                         minWidth: '20vh'
                         , overflowY: 'hidden'
                         , height: '73vh'
                         , maxWidth: '33vh'
                     }}
                >
                    <button
                        type="button"
                        className="m-1 collapse-handler p-3 font-medium  bg-white"
                    >
                        {title}
                    </button>
                    <ReactCSSTransitionGroup
                        transitionName="fade"
                        transitionEnterTimeout={500}
                        transitionLeaveTimeout={300}
                    >
                        {collapse === false ? null : (
                            <div className="border-t border-gray-200  ">
                                <SearchBar
                                    ref={this.searchBar}
                                    posts={tools}
                                    setSearchResults={e => this.setList(e)}
                                />
                                {tools != null && Object.keys(tools).length > 0 ? (
                                    <p className="p-2  border-b border-gray-200 text-gray-400  font-extralight"
                                       style={{fontSize: '0.9em'}}>
                                        You can drag and drop document anywhere on the page.</p>
                                ) : null}
                                <div
                                    style={{
                                        overflowY: 'scroll',
                                        overflowX: 'hidden',
                                        height: '55vh',
                                        minWidth: '11.5vh',
                                        maxWidth: '31.5vh'
                                        , position: 'relative'
                                    }}>
                                    {ShowLoaderFile && <Loader
                                        wrapperBackgroundColor={'transparent'}
                                        fullScreen={false}
                                        color={'rgba(75, 85, 99 )'}
                                        textStyles={{
                                            color: 'red',
                                            fontSize: '22px',
                                            fontWeight: '500',
                                            textShadow: '3px 3px 6px rgb(0 0 0/26%),0 0 5px rgb(15 3 86/22%)'
                                        }}
                                        fadeIn={true}
                                    />
                                    }
                                    <div style={{
                                        zIndex: 555555555555555
                                    }}
                                         rmthumb="1"
                                         id="contextmenu"
                                    >
                                        <ControlledMenu
                                            anchorPoint={this.state.AnchorPoint}
                                            state={this.state.ContextMenuState}
                                            onClose={() => this.setState({ContextMenuState: 'closed'})}
                                            onMouseDown={e => e.stopPropagation()}
                                            transition={true}
                                        >
                                            {/*
                                              ─── M2: Share / Make Private menu items ───
                                              Visible only when the right-clicked doc belongs
                                              to the current user. Backend enforces ownership
                                              too — these items are just so non-owners don't
                                              see options that would 403 on click.

                                              Logic:
                                                - private + owner   → "Share with Team"
                                                - account + owner   → "Make Private"
                                                - non-owner         → neither shown
                                            */}
                                            {this.state.FileIsOwner && this.state.FileVisibility === 'private' && (
                                                <MenuItem className={btnMenuItemClass}
                                                          onClick={this.handleShareWithTeam}
                                                >
                                                    <table>
                                                        <tbody>
                                                        <tr>
                                                            <td style={{width: btnMenuIconWidth}}>
                                                                <i className="fas fa-users"
                                                                   style={{fontSize: btnMenuIconSize, color: '#3b82f6'}}/>
                                                            </td>
                                                            <td><p className={btnMenuTextClass}>Share with Team</p></td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </MenuItem>
                                            )}
                                            {this.state.FileIsOwner && this.state.FileVisibility === 'account' && (
                                                <MenuItem className={btnMenuItemClass}
                                                          onClick={this.handleMakePrivate}
                                                >
                                                    <table>
                                                        <tbody>
                                                        <tr>
                                                            <td style={{width: btnMenuIconWidth}}>
                                                                <i className="fas fa-lock"
                                                                   style={{fontSize: btnMenuIconSize, color: '#9ca3af'}}/>
                                                            </td>
                                                            <td><p className={btnMenuTextClass}>Make Private</p></td>
                                                        </tr>
                                                        </tbody>
                                                    </table>
                                                </MenuItem>
                                            )}
                                            <MenuItem className={btnMenuItemClass}
                                                      onClick={(e) => this.deleteFile(this.state.FileName)}
                                            >
                                                <table>
                                                    <tbody>
                                                    <tr>
                                                        <td style={{width: btnMenuIconWidth}}>
                                                            <i className="fas fa-trash"
                                                               style={{fontSize: btnMenuIconSize}}/>
                                                        </td>
                                                        <td><p className={btnMenuTextClass}>Delete</p></td>
                                                    </tr>
                                                    </tbody>
                                                </table>
                                            </MenuItem>
                                        </ControlledMenu>
                                    </div>
                                    {liste &&
                                        liste.map((tool, i) => (
                                            <ToolFileExplorer
                                                Explorer={1}
                                                key={i}
                                                icon={tool.icon}
                                                properties={tool.properties}
                                                type={tool.type}
                                                title={tool.title}
                                                Name={tool.Name}
                                                Date={tool.Date}
                                                Thumb={tool.Thumb64}
                                                Visibility={tool.Visibility}
                                                IsOwner={tool.IsOwner}
                                                OwnerEmail={tool.OwnerEmail}
                                                setContextMenuState={(e) => {
                                                    this.setState({ContextMenuState: e})
                                                }}
                                                ContextMenuState={this.state.ContextMenuState}
                                                setAnchorPoint={(e) => {
                                                    this.setState({AnchorPoint: e})
                                                }}
                                                AnchorPoint={this.state.AnchorPoint}
                                                setFileName={(e) => {
                                                    this.setState({FileName: e})
                                                }}
                                                setFileMetadata={(meta) => {
                                                    // ─── M2: track the right-clicked doc's
                                                    // visibility/ownership so the menu can
                                                    // render the correct Share/Make-Private item.
                                                    this.setState({
                                                        FileVisibility: meta.visibility || 'private',
                                                        FileIsOwner: !!meta.isOwner
                                                    })
                                                }}
                                            />
                                        ))}
                                </div>
                            </div>
                        )}
                    </ReactCSSTransitionGroup>
                </div>
            </div>
        );
    };
}

export default PanelFileExplorer;
